import * as React from 'react';

import { StyledTag } from '../styles';

interface TagProps {
	index: number;
	label: string;
	isActive: boolean;
	onToggle: (index: number) => void;
}

const Tag = ({ index, label, isActive, onToggle }: TagProps) => (
	<StyledTag
		isActive={isActive}
		onClick={() => onToggle(index)}
	>
		{label}
	</StyledTag>
);

export default Tag;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/TagsList/Tag/index.tsx